import axios from 'axios'

const base_url = `${process.env.VUE_APP_API_PATH}`;

export default {
    getTravelOffers(user_email) {
        const url = `${base_url}/travel-agency/offers`;

        return axios.post(url, user_email)
    },
    addTravelCompany(travel_company) {
        const url = `${base_url}/travel-agency`;

        return axios.post(url, travel_company)
    },


    addTravelOffers(travel_offer) {
        const url = `${base_url}/travel-agency/add-offers`;

        return axios.post(url, travel_offer)
    },

    deleteTravelOffers(delete_offer_id) {

        const url = `${base_url}/travel-agency/delete-offer`;

        return axios.delete(url, delete_offer_id)
    }

}
